import { useCallback, useState } from 'react';
import {
  InfluencerPplDetailDialog,
  InfluencerPplSnapshot,
} from '@/components/Approval/@components/InfluencerPpl';
import {
  parseInfluencerPplContent,
  parseInfluencerPplSavedInfo,
  pickInfluencerPplDetailInfo,
} from '@/utils/approval/influencerPpl';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 135 인플루언서 PPL 정산 — 저장 content 그대로, 그래프·「상세보기」는 저장한 리포트 데이터로(레거시 동일) */
const InfluencerPplSlot = ({ data }: ContentExtraProps) => {
  const [detailOpen, setDetailOpen] = useState(false);
  const openDetail = useCallback(() => setDetailOpen(true), []);

  const content = parseInfluencerPplContent(data.attributes);
  const info = parseInfluencerPplSavedInfo(data.attributes);
  if (!content) return null;
  const brand = data.attributes?.brand;
  return (
    <ContentSlotRoot>
      <InfluencerPplSnapshot
        content={content}
        info={info}
        showExposure
        onOpenDetail={openDetail}
      />
      <InfluencerPplDetailDialog
        open={detailOpen}
        onClose={() => setDetailOpen(false)}
        brand={typeof brand === 'string' ? brand : ''}
        detailInfo={pickInfluencerPplDetailInfo(info)}
      />
    </ContentSlotRoot>
  );
};

export default InfluencerPplSlot;
